var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.text)?_c('div',{staticClass:"MagCeHeading",class:[
    _vm.data.el_class,
    _vm.data.animation_in ? ("animate__animated animate__" + (_vm.data.animation_in) + " animate__delay-1s") : '',
    _vm.data.animation_delay ? ("animate__delay-" + (_vm.data.animation_delay) + "s") : '',
    _vm.data.animation_infinite ? "animate__infinite" : '' ],attrs:{"id":_vm.data.id}},[_c(("" + (_vm.data.heading_type)),{tag:"component"},[_vm._v(_vm._s(_vm.data.text))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }